// extracted by mini-css-extract-plugin
export var clips = "index-module--clips--ApnW+";
export var clipsContainer = "index-module--clips-container--KJnmm";
export var clip1 = "index-module--clip-1--EXbyC";
export var clip2 = "index-module--clip-2--T0Zr0";